import script from "./TradingStrategyView.vue?vue&type=script&setup=true&lang=js"
export * from "./TradingStrategyView.vue?vue&type=script&setup=true&lang=js"

import "./TradingStrategyView.vue?vue&type=style&index=0&id=572a313f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-572a313f"]])

export default __exports__